import React from "react";

const MasterRoute = ({ children }) => {
    return children;
};

export default MasterRoute;
